import { Core } from 'chessboard/core/config/types';
import { is } from 'src/utils/app/model/is';
import type { Markings } from 'chessboard/plugins/markings/config/types';

/**
 * Determine if it's an Unark event of a specific type. It's a curried function
 * designed to be used as a helper in the `condition` property of a `match`.
 */
export function isUnmark(type: string) {
  return function isMarkingOfType(event: Core.Event) {
    return (
      is(Core.APIEvents.Unmark)(event) &&
      event.data.find?.((marking: Markings.Model) => marking.type === type)
    );
  };
}
